module.exports = __webpack_public_path__ + "media/images/matrix_preview_landscape-e4ded85b7cf7291383963d1d4c526819.png";